var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "position-x": _vm.position.x,
        "position-y": _vm.position.y,
        "close-on-content-click": false,
        "nudge-width": 300,
        "offset-x": "",
      },
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-form",
        { ref: "form", staticStyle: { width: "100%" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "title py-1" },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.type) + " recipient\n        "
                  ),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Email*",
                      rules: [_vm.rules.required, _vm.rules.email],
                      "error-messages": _vm.errorMessages.email,
                    },
                    model: {
                      value: _vm.formObject.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.formObject, "email", $$v)
                      },
                      expression: "formObject.email",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Name" },
                    model: {
                      value: _vm.formObject.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formObject, "name", $$v)
                      },
                      expression: "formObject.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                {},
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", outline: "" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Save")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }